:root,
.ux-theme-web {
  --ux-account-switch-background: #eff0f4;
  --ux-account-switch-button-background: #fff;
  --ux-account-switch-button-background-hover: #005074;
  --ux-account-switch-button-height: 40px;
  --ux-account-switch-button-margin: 5px 0;
  --ux-account-switch-button-padding: 10px;
  --ux-account-switch-button-text: #5a5a5a;
  --ux-account-switch-button-text-align: start;
  --ux-account-switch-button-text-hover: #fff;
  --ux-account-switch-font: var(--ux-font);
  --ux-account-switch-font-size: 14px;
  --ux-account-switch-footer-background: #c3cfd6;
  --ux-account-switch-footer-background-hover: #005074;
  --ux-account-switch-footer-font-weight: 700;
  --ux-account-switch-footer-height: 44px;
  --ux-account-switch-footer-justify-content: center;
  --ux-account-switch-footer-text: #0b0b0b;
  --ux-account-switch-footer-text-hover: #fff;
  --ux-account-switch-footer-text-transform: uppercase;
  --ux-account-switch-list-padding: 10px 20px;
  --ux-account-switch-text: #5a5a5a;
  --ux-account-switch-title-font-weight: 700;
  --ux-account-switch-title-text-transform: uppercase;
  --ux-account-switch-transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
}

.uic-theme-responsive,
.ux-theme-responsive {
  --ux-account-switch-background: #fff;
  --ux-account-switch-button-background: var(--uic-color-grey1, #e7ecf0);
  --ux-account-switch-button-background-hover: var(--uic-color-blue4, #285172);
  --ux-account-switch-button-height: 40px;
  --ux-account-switch-button-margin: 5px 0;
  --ux-account-switch-button-padding: 10px;
  --ux-account-switch-button-text: var(--uic-color-black, #000);
  --ux-account-switch-button-text-align: start;
  --ux-account-switch-button-text-hover: var(--uic-color-white, #fff);
  --ux-account-switch-font: "Open Sans", sans-serif;
  --ux-account-switch-font-size: 14px;
  --ux-account-switch-footer-background: var(--ux-account-switch-button-background);
  --ux-account-switch-footer-background-hover: var(--ux-account-switch-button-background-hover);
  --ux-account-switch-footer-font-weight: 400;
  --ux-account-switch-footer-height: var(--ux-account-switch-button-height);
  --ux-account-switch-footer-justify-content: flex-start;
  --ux-account-switch-footer-text: var(--ux-account-switch-button-text);
  --ux-account-switch-footer-text-hover: var(--ux-account-switch-button-text-hover);
  --ux-account-switch-footer-text-transform: none;
  --ux-account-switch-list-padding: 10px 0 0;
  --ux-account-switch-text: var(--uic-color-black, #000);
  --ux-account-switch-title-font-weight: 400;
  --ux-account-switch-title-text-transform: none;
  --ux-account-switch-transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
}

:root,
.uic-theme-responsive,
.ux-theme-responsive {
  --uxc-app-header-height: 52px;
  --uxc-app-header-expandables-y-offset: 56px;
  --uxc-app-header-expandables-min-width: 300px;
  --uxc-app-header-z-index: 400;
  --uxc-app-header-bg-color: var(--uic-color-blue5);
  --uxc-app-header-separator-color: var(--uic-color-white);
  --uxc-app-header-launcher-width: 68px;
  --uxc-app-header-breakpoint-burger-menu: 680px;
}

@media only screen and (min-width: 1024px) {
  .uic-theme-responsive,
  .ux-theme-responsive {
    --uxc-app-header-height: 68px;
    --uxc-app-header-expandables-y-offset: 72px;
    --uxc-app-header-launcher-width: 85px;
  }
}
:root,
.uic-theme-responsive {
  --uxc-app-toast-notifications-z-index: 350;
}

:root {
  --ux-flyout-bg-color: #fff;
  --ux-flyout-content-min-height: 220px;
  --ux-flyout-content-padding: 17px 12px 17px 12px;
  --ux-flyout-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05), 0 8px 8px 0 rgba(161, 161, 161, 0.4);
  --ux-flyout-width: 296px;
  --ux-flyout-max-width: calc(100vw - 40px);
  --ux-flyout-z-index: 390;
}

@media only screen and (min-width: 769px) {
  :root {
    --ux-flyout-width: 320px;
  }
}
@media only screen and (min-width: 1920px) {
  :root {
    --ux-flyout-width: 384px;
  }
}
/**
* CSS Custom Properties for menu item styling
*
* @prop --uxc-menu-item-background-color: Background color of the menu item (default: #142939).
* @prop --uxc-menu-item-background-color-hover: Background color of the menu item on hover (default: #2c3e4d).
* @prop --uxc-menu-item-text-color: Text color of the menu item (default: #fff).
* @prop --uxc-menu-item-text-color-active: Text color of the menu item when active/current/focused (default: #51a7eb).
* @prop --uxc-menu-item-text-color-disabled: Text color of the menu item when disabled.
* @prop --uxc-menu-item-divider-color: Color of the menu item divider line (default: #fff).
* @prop --uxc-menu-item-dropdown-width: Width of the submenu dropdown (default: 300px).
* @prop --uxc-menu-item-dropdown-offset: Vertical offset of the submenu dropdown.
* @prop --uxc-menu-item-dropdown-left: Left position of the submenu dropdown (default: 0).
* @prop --uxc-menu-item-dropdown-right: Right position of the submenu dropdown (default: auto).
* @prop --uxc-menu-item-expanded-indicator-display: Display property for the expanded indicator (default: none).
* @prop --uxc-menu-item-justify: Justify-content for menu item layout (default: stretch).
* @prop --uxc-menu-item-label-display: Display property for the label (default: block).
* @prop --uxc-menu-item-min-height: Minimum height of the menu item (default: 52px).
* @prop --uxc-menu-item-min-width: Minimum width of the menu item (default: 52px).
* @prop --uxc-menu-item-font-size: Font size of the menu item (default: 1rem).
* @prop --uxc-menu-item-font-weight: Font weight of the menu item (default: 700).
* @prop --uxc-menu-item-line-height: Line height of the menu item (default: 1.3).
*/
:root {
  --uxc-menu-item-background-color: #142939;
  --uxc-menu-item-background-color-hover: #2c3e4d;
  --uxc-menu-item-text-color: #fff;
  --uxc-menu-item-text-color-active: #51a7eb;
  --uxc-menu-item-text-color-disabled: #ccc;
  --uxc-menu-item-min-height: 52px;
  --uxc-menu-item-min-width: var(--uxc-menu-item-min-height);
  --uxc-menu-item-font-size: 1rem;
  --uxc-menu-item-font-weight: 700;
  --uxc-menu-item-line-height: 1.3;
  --uxc-menu-item-divider-color: #fff;
  --uxc-menu-item-dropdown-width: 300px;
  --uxc-menu-item-dropdown-offset: 4px;
  --uxc-menu-item-label-display: block;
  --uxc-menu-item-expanded-indicator-display: none;
}
@media screen and (min-width: 1024px) {
  :root {
    --uxc-menu-item-min-height: 68px;
  }
}

.uxc-app-sidebar-notifications {
  width: 100%;
  position: relative;
}
.uxc-app-sidebar-notifications__inner {
  display: none;
}
.uic-sidebar--opening .uxc-app-sidebar-notifications__inner, .uic-sidebar--opened .uxc-app-sidebar-notifications__inner {
  display: block;
}
.uxc-app-sidebar-notifications .uic-sidebar {
  width: var(--uxc-app-header-expandables-min-width);
  color: var(--uic-color-black);
  background: var(--uic-color-white);
  box-shadow: var(--uic-flyout-shadow);
  transition: none;
}
.uxc-app-sidebar-notifications .uic-sidebar--align-header {
  top: var(--uxc-app-header-expandables-y-offset);
}
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-left.uic-sidebar--opened, .uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-left.uic-sidebar--opening, .uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-left.uic-sidebar--closed, .uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-left.uic-sidebar--closing,
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-right.uic-sidebar--opened,
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-right.uic-sidebar--opening,
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-right.uic-sidebar--closed,
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-right.uic-sidebar--closing {
  transform: none;
  transition: none;
}
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-left.uic-sidebar--closing,
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-right.uic-sidebar--closing {
  display: none;
}